import React from "react";
import { string } from "prop-types";
import { connect } from "react-redux";

import DfpAd from "../../dfp-ad";

import "./topAd.m.css";

const TopAd = ({ pageType, currentPath }) => {
  if (pageType === "not-found") return null;

  return (
    <div styleName="ad-slot">
      <DfpAd
        adtype={`Haal_Fashion_${pageType === "home-page" ? "HP" : "News"}_T1`}
        topAd={true}
        slotId={`header-ad-${currentPath}`}
      />
    </div>
  );
};

TopAd.propTypes = {
  pageType: string,
  currentPath: string,
};

const mapStateToProps = (state) => ({
  pageType: state.qt.pageType,
  currentPath: state?.qt?.currentPath,
});

export default connect(mapStateToProps)(TopAd);
